document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".tour-date-input").forEach(input => {
        input.addEventListener("change", async (e) => {
            const date = e.target.value;
            const variantId = e.target.dataset.variantId;
            if (!variantId || !date) return;
            try {
                const response = await fetch("/cart/change.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json"
                    },
                    body: JSON.stringify({
                        id: variantId,
                        quantity: 1,
                        properties: {
                            date: date
                        }
                    })
                });

                const data = await response.json();
                console.log("Cart updated", data);

                // Optional: Reload the cart or part of the page
                location.reload(); // or update the cart DOM dynamically
            } catch (err) {
                console.error("Error updating cart:", err);
            }
        });
    });
});
